<div
  appClickedOutside
  (clickedOutside)="onClickOutside()"
  class="container-customer-account-list"
  [ngClass]="{'single-account': accountsByCustomer.length === 1}"
>
  <div class="header">
    <h4 *ngIf="accountsByCustomer.length > 1"> {{'general.PARENT_ACCOUNT' | transloco}}</h4>
    <h4>{{'general.ACCOUNT' | transloco}}</h4>
  </div>
  <div class="rows">
    <div *ngFor="let customer of accountsByCustomer" class="row">
      <div *ngIf="accountsByCustomer.length > 1" class="customer">
        <div>
          <img *ngIf="customer.customerName == selectedAccountInfo?.customerName" src="assets\icons\check-mark.svg"  alt="{{'general.CHECKMARK' | transloco}}"/>
        </div>
        <p>{{customer.customerName}}</p>
      </div>
      <div class="accounts" [ngClass]="{'single-account': accountsByCustomer.length === 1}">
        <div *ngFor="let account of customer.accountInfos" class="account" (click)="selectOption(account)">
          <div>
            <img *ngIf="account.name == selectedAccountInfo?.name" src="assets\icons\check-mark.svg"  alt="{{'general.CHECKMARK' | transloco}}"/>
          </div>
          <p>{{account.name}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
